import { ref, set } from 'firebase/database'
import { database } from '../config/firebase'

export function sendMessageToDB(values) {
  const timeStamp = new Date().getTime()
  const db = database
  try {
    set(ref(db, 'customer_message/' + timeStamp), {
      company_name: values.name,
      name: values.name,
      email: values.email,
      message: values.message,
    })
  } catch (error) {
    console.error('送出失敗')
  }
}
